<template>
<div class="context--item--wrapper" v-closable="{ exclude: ['ContextItemAutoComplete'], isClosable: true, handler: 'handleCancel'}">
  <div :ref= "'ContextItemAutoComplete'" class="context--item--autocomplete--wrapper"
    :class="{'hovered': isEditing}"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <div @[eventName]="handleGlobalEditing" class="context--item--autocomplete--container" :class="[{'editing': isEditing}]">
    <div v-if="icon !== null && !isLoading" class="icon">
      <v-tooltip left :disabled="iconTooltip === null">
        <template v-slot:activator="{ on }">
          <v-icon v-on="on">{{ icon }}</v-icon>
        </template>
        <span>{{ iconTooltip }}</span>
      </v-tooltip>
    </div>
    <div v-if="label !== null" class="label">
      <span>
        {{label}}
      </span>
    </div>
    <div class="value">
      <span
      v-show="!isEditing"
      >
      {{ value != null ? translate != null ? $t(`${translate}.${value}`) : value : emptyValue }}
      </span>
      <input
        v-model="search"
        v-show="isEditing"
        :ref="'wrld_autocomplete_input'"
        class="editable--value"
        :placeholder="value != null ? translate != null ? $t(`${translate}.${value}`) : value : emptyValue"
        @input="handleInput"
      />
    </div>
    </div>
    <div v-show="hover || isEditing" class="actions--panel">
        <div class="icon-action" v-for="(action, index) in actions" :key="'action-' + index">
          <v-tooltip top :disabled="action.tooltip === undefined || action.tooltip === ''">
            <template v-slot:activator="{ on }">
              <v-icon v-if="action !== null" size="14" v-on="on" @click="action.callback">{{action.icon}}</v-icon> <!-- dependence on Vuetify   -->
            </template>
            <span>{{ action.tooltip }}</span>
          </v-tooltip>
        </div>
      </div>
    <div v-show="isEditing && computedList.length > 0" :ref="'wrld_autocomplete_list'" :class="[{'bottom': bottom}, {'top': openUpwards}, `list--height--${computedList.length}`]" class="autocomplete--list">
      <ul>
        <template v-for="({ id, text } ,index) in computedList">
          <li @click="handleSelect(index)" :key="id">{{
            translate != null ? $t(`${translate}.${text}`) : text
          }}</li>
        </template>
      </ul>
    </div>
  </div>
</div>
</template>

<script>
import { generalHelpers } from '@/_helpers'
export default {
  name: 'ContextItemAutoComplete',
  props: {
    icon: { type: String, default: null },
    iconTooltip: { type: String, default: null },
    isLoading: { type: Boolean, default: false },
    isCopyable: { type: Boolean, default: false },
    value: { type: String, default: '' },
    bottom: { type: Boolean, default: false },
    openUpwards: { type: Boolean, default: false },
    list: { type: Array, default: () => [] },
    text: { type: String, default: 'text' },
    searchable: { type: Array, default: () => ['text'] },
    label: { type: String, default: null },
    eventName: { type: String, default: '' },
    emptyValue: { type: String, default: '' },
    translate: {type: String, default: null}
  },
  data () {
    return {
      hover: false,
      isEditing: false,
      localList: [],
      searchingList: [],
      search: '',
      selected: null
    }
  },
  mounted () {
    this.handleInit()
  },
  methods: {
    handleInit () {
      this.search = ''
      this.localList = []
      this.searchingList = []
      this.localList = [...this.list.map((item) => {
        let itemSearchable = ''
        this.searchable.forEach((key) => {
          itemSearchable += item[key]
        })
        return { ...item, 'text': item[this.text], searchable: itemSearchable }
      })]
      // if (this.selected === null) {
      //   const selectedIndex = this.list.findIndex(({ text }) => text === this.value)
      //   if (selectedIndex > -1) {
      //     this.selected = JSON.parse(JSON.stringify(this.list[selectedIndex]))
      //   }
      // }
      // if (this.selected !== null) {
      //   this.searchingList = this.localList.filter(({ id }) => id !== this.selected.id)
      // } else {
      //   this.searchingList = [...this.localList]
      // }
      this.searchingList = [...this.localList]

    },
    handleEditing () {
      this.isEditing = !this.isEditing
      if (this.isEditing) {
        this.$nextTick(() => {
          this.$refs['wrld_autocomplete_input'].focus()
        })
      }
    },
    handleGlobalEditing () {
      this.isEditing = true
      if (this.isEditing) {
        this.$nextTick(() => {
          this.$refs['wrld_autocomplete_input'].focus()
        })
      }
    },
    handleSelect (index) {
      const indexFound = this.list.findIndex(({ text }) => { return this.computedList[index].text === text })
      this.$emit('autocompleteSelection', this.list[indexFound].text)
      this.selected = this.list[indexFound]
      this.search = this.list[indexFound].text
      this.handleSave()
    },
    handleInput (evt) {
      this.search = evt.target.value
    },
    handleSave () {
      if (this.selected !== null) {
        this.$emit('autocompleteSave', this.selected)
        this.handleInit()
      }
      this.isEditing = false
    },
    handleCancel () {
      this.isEditing = false
      this.handleInit()
    }
  },
  computed: {
    actions: function () {
      if (!this.isEditing) {
        if (!this.isCopyable) {
          return [
            {
              icon: 'edit',
              tooltip: this.$i18n.t('buttons.edit'),
              callback: this.handleEditing
            }
          ]
        } else {
          return [
            {
              icon: 'edit',
              tooltip: this.$i18n.t('buttons.edit'),
              callback: this.handleEditing
            },
            {
              icon: 'far fa-copy',
              tooltip: this.$i18n.t('buttons.copy'),
              callback: () => generalHelpers.copyToClipboard(this.value)
            }
          ]
        }
      } else {
        return [
          {
            icon: 'fas fa-times',
            tooltip: this.$i18n.t('buttons.cancel'),
            callback: this.handleCancel
          }
          // {
          //   icon: 'fas fa-save',
          //   tooltip: 'Save',
          //   callback: this.handleSave
          // }
        ]
      }
    },
    computedList: function () {
      return this.searchingList
    }
  },
  watch: {
    search: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        if (val.length > 0) {
          this.searchingList = [...this.localList.filter(({ searchable }) => {
            return searchable.toLowerCase().includes(val.toLowerCase())
          })]
        } else {
          this.searchingList = [...this.localList]
        }
      }
    },
    list: {
      deep: true,
      immediate: true,
      handler (val, oldVal) {
        this.handleInit()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.context--item--autocomplete--wrapper {
  position: relative;
  border-radius: 5px;
  width: 100%;
  .autocomplete--list {
    background-color: white;
    width: 100%;
    // max-height: 75px;
    overflow-y: auto;
    border-radius: 5px;
    border: 2px solid #767676;
    padding: 0 5px;
    ul {
      list-style-type: none;
      padding: 0;
      li {
        cursor: pointer;
        color: #767676;
        font-size: 13px;
        font-weight: bold;
        margin-bottom: 5px;
        padding-left: 10px;
        border-radius: 5px;
        width: 100%;
        height: 100%;
        z-index: 9;
        display: block;
        &:hover {
          background-color: #f2f2f2;
        }
      }
    }
    z-index: 8;
    position: absolute;
    &.top {
      overflow: auto;
      bottom: 105%;
      // top: 0;
      max-height: 300px;
      transition: all 0.4s linear;
    }
    // top: 30px;
    // left: 0;
    &.bottom {
      &.list--height--1 {
        top: -120%;
      }
      &.list--height--2 {
        top: -200%;
      }
      top: -300%;
    }
  }
  &.hovered {
     background-color: #f2f2f2;
  }
  &:hover {
    background-color: #f2f2f2;
  }
  .context--item--autocomplete--container {
    position: relative;
    padding-left: 5px;
    display: flex;
    flex-direction: row;
    align-content: flex-start;
    flex-wrap: nowrap;
    flex-direction: row;
    align-items: left;
    justify-content: flex-start;
    border: 2px solid transparent;
    border-radius: 5px;
    margin-bottom: 1px;
    &.editing {
      border-color: #767676;
    }
    .icon {
      i {
        color: #767676;
        font-size: 16px;
      }
      flex: 1 1 25%;
      margin-right: 15px;
      max-width: 16px;
    }
    .label {
      span {
        color: #484848;
        font-size: 13px;
        font-weight: bold;
      }
      flex: 1 1 max-content;
      margin-right: 5px;
    }
    .value {
      text-align: left;
      span {
        color: #767676;
        font-size: 13px;
        font-weight: bold;
        max-width: 100%;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        padding-top: 2px;
      }
      flex: 1 1 50%;
    }
    .editable--value {
      appearance: none;
      -moz-appearance: none;
      -webkit-appearance: none;
      border-radius: 0;
      -moz-border-radius: 0;
      -webkit-border-radius: 0;
      outline: none;
      border: none;
      background-color: transparent;
      color: inherit;
      font-family: inherit;
      color: #767676;
      &::placeholder {
        color: #48484880
      }
      font-weight: bold;
      font-size: 13px;
      width: 100%;
    }
  }
  .actions--panel {
    position: absolute;
    right: 3px;
    top: 2px;
    z-index: 9;
    background-color: #f2f2f2;
    height: calc(100% - 5px);
    display: flex;
    border-left: 1px solid #ededed;

    .icon-action {
      position: relative;
      top: 0;
      width: 20px;
      height: 20px;
      text-align: center;
      border-radius: 5px;
      i {
        color: #767676;
        font-size: 18px;
      }
      &:hover {
        background-color: #e0e0e0;
      }
    }
  }
}
</style>
